import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

const ErrorContent = ({ title, description }: { title: string; description: string }) => {
  return (
    <>
      <Box gap="s4" flexDirection="row">
        <Icon.Medium icon="alert-circle-line" color="radicalRed1000" />
        <Text.Header2>{title}</Text.Header2>
      </Box>
      <Box>{description}</Box>
    </>
  )
}

export default ErrorContent
